// "Obróć telefon" — a full-screen cover shown on an upright phone (ui/rotateRule.mjs). The game
// keeps running underneath and is back the moment the phone is turned; the cover sits above
// every other overlay (joystick 1500, chat 1600, modals) so no tap reaches the tiny canvas.
import { needsRotate } from './rotateRule.mjs';
import { isTouchDevice } from './isTouchDevice.js';

const PHONE_SVG = `<svg viewBox="0 0 120 120" width="132" height="132" aria-hidden="true">
  <g class="rp-phone">
    <rect x="38" y="14" width="44" height="92" rx="9" fill="#fff4dc" stroke="#ffd166" stroke-width="5"/>
    <rect x="45" y="25" width="30" height="64" rx="3" fill="#2b3a67"/>
    <circle cx="60" cy="97" r="3.5" fill="#ffd166"/>
  </g>
  <path d="M100 38 a44 44 0 0 1 4 34" fill="none" stroke="#ffffff99" stroke-width="5" stroke-linecap="round"/>
  <path d="M97 68 l7 7 l5 -9" fill="none" stroke="#ffffff99" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

export function mountRotatePrompt(win = window) {
  const touch = isTouchDevice(win);
  if (!touch) return null;
  const style = win.document.createElement('style');
  style.textContent = `
    #rotate-prompt { position:fixed; inset:0; z-index:5000; display:none; flex-direction:column;
      align-items:center; justify-content:center; gap:18px; background:#0f1027; color:#fff;
      text-align:center; padding:24px; touch-action:none; user-select:none; }
    #rotate-prompt h1 { margin:0; font-size:30px; font-weight:700; }
    #rotate-prompt p { margin:0; font-size:17px; color:#c9cdf0; max-width:280px; }
    #rotate-prompt .rp-phone { transform-origin:60px 60px; animation:rp-turn 2.4s ease-in-out infinite; }
    @keyframes rp-turn { 0%,25% { transform:rotate(0deg); } 55%,90% { transform:rotate(90deg); } 100% { transform:rotate(0deg); } }
    @media (prefers-reduced-motion: reduce) { #rotate-prompt .rp-phone { animation:none; transform:rotate(90deg); } }`;
  win.document.head.appendChild(style);
  const cover = win.document.createElement('div');
  cover.id = 'rotate-prompt';
  cover.setAttribute('role', 'alert');
  cover.innerHTML = `${PHONE_SVG}<h1>Obróć telefon</h1><p>Gra działa w poziomie — obróć telefon bokiem.</p>`;
  win.document.body.appendChild(cover);
  const sync = () => {
    const on = needsRotate({ touch, width: win.innerWidth, height: win.innerHeight });
    cover.style.display = on ? 'flex' : 'none';
  };
  win.addEventListener('resize', sync);
  win.addEventListener('orientationchange', sync);
  sync();
  return cover;
}
